import { render } from "./PatientServices.vue?vue&type=template&id=65945be3&scoped=true"
import script from "./PatientServices.vue?vue&type=script&lang=js"
export * from "./PatientServices.vue?vue&type=script&lang=js"

import "./PatientServices.vue?vue&type=style&index=0&id=65945be3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65945be3"]])

export default __exports__